export default __webpack_public_path__ + "static/media/fridge2-afterA-1920w.5a7e3880.png";